<template>
  <div class="loading-overlay" v-if="isLoading">
    <div class="loading-spinner"></div>
    <p>{{text}}...</p>
  </div>
</template>

<script>
export default {
    name: 'Loading',
    props: {
        isLoading: {
            type: Boolean,
            default: false
        },
        text: {
            type: String,
            default: 'Loading'
        }
    }
};
</script>

<style scoped>
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.loading-spinner {
  border: 8px solid rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  border-top: 8px solid #fff;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

p {
  color: #fff;
  margin-top: 10px;
}
</style>
